import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import { axiosInstance } from "../component/Api/instance";
import { UserContext } from "../Context";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const TOTAL_PARTS = 4;
const PART_DURATION = 45 * 60;

const CountdownTimer = () => {
  const [currentPart, setCurrentPart] = useState(1);
  const { time, setTime } = useContext(UserContext);
  const email = localStorage.getItem("userMail");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { isPaused, setIsPaused } = useContext(UserContext);

  useEffect(() => {
   const STORAGE_KEY = `timer_${email}_${currentPart}`;

   const saved = localStorage.getItem(STORAGE_KEY);

   if (saved) {
     setTime(Number(saved));
   } else {
     setTime(PART_DURATION);
     localStorage.setItem(STORAGE_KEY, PART_DURATION);
   }
  }, [currentPart]);


  const initializePartTimer = async (part) => {
    try {
      const response = await axiosInstance.post("get/U_ViewMainsTimer.php", {
        userId: email,
        part,
      });
      setTime(PART_DURATION);
      localStorage.setItem(`timer_part_${part}`, PART_DURATION);
    } catch (err) {

      console.error(err);
      setTime(PART_DURATION);
    }
  };

  useEffect(() => {
  if (isPaused || time === null) return;

  if (time <= 0) {
    if (currentPart < TOTAL_PARTS) {
      setModalIsOpen(true);
      setTimeout(() => {
        setModalIsOpen(false);
        setCurrentPart((prev) => prev + 1);
      }, 1000);
    } else {
      console.log("Test Completed");
    }
    return;
  }

  const interval = setInterval(() => {
    setTime((prev) => {
      if (prev <= 0) return 0;

      const updated = prev - 1;
      localStorage.setItem(`timer_part_${currentPart}`, updated);
      return updated;
    });
  }, 1000);

  return () => clearInterval(interval);
}, [time, isPaused, currentPart]);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div style={{ textAlign: "center", display: "flex" }}>
      {time !== null ? <p>TIME: {formatTime(time)}</p> : <p>Loading...</p>}

      <button
        onClick={() => setIsPaused(!isPaused)}
        style={{
          background: "white",
          color: "black",
          border: "none",
          cursor: "pointer",
          marginBottom: "14px",
          marginLeft: "20px",
        }}
      >
        {isPaused ? (
          <PlayArrowIcon style={{ fontSize: "20px" }} />
        ) : (
          <PauseIcon style={{ fontSize: "20px" }} />
        )}
      </button>

      <Modal show={modalIsOpen}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <p style={{ fontWeight: "bold" }}>Time's Up!</p>
        </div>
      </Modal>
    </div>
  );
};

export default CountdownTimer;
